import Dashboard from "./ProMajaziDashboard";
import ProMajaziTokens from "./ProMajaziTokens";

// نکته: children اینجا به‌صورت مسیر «مستقل ولی هم‌سطح» ساخته میشن
// (یعنی /panel/manage-shops/:shopId/pages یه Route جداگانه‌ست، نه چیزی
// که داخل <Outlet /> کامپوننت ManageShops رندر بشه). به همین خاطر لازم
// نیست ManageShops.jsx خودش Outlet داشته باشه — وقتی کاربر وارد یکی
// از این مسیرها بشه، کلاً به‌جای ManageShops همون کامپوننت فرزند رندر میشه.
//
// برای صفحه‌ای که child نداره، فقط id و Component رو بنویس.
export const PAGE_ROUTES = [
  { id: "dashboard", Component: Dashboard },
  { id: "tokens", Component: ProMajaziTokens },
];

// برای سازگاری با کدهای قدیمی که هنوز از PAGE_COMPONENTS استفاده می‌کنن
// (مثلاً اگه جای دیگه‌ای از پروژه بهش رفرنس داده شده)
export const PAGE_COMPONENTS = Object.fromEntries(
  PAGE_ROUTES.map(({ id, Component }) => [id, Component]),
);
